'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';
import { Material } from 'modules/material';
import { Aks } from 'modules/aksses';
import { Embroidery } from 'modules/embroidery';
import { AjaxUpdate } from 'modules/ajax-update';
import { AjaxCart } from 'modules/ajax-cart';
import { FlexLink } from 'modules/flexlink';

class AjaxLoadPage {
  constructor() {
      this.init();
  }
  init() {
      console.log('[ AjaxLoadPage ] init');
      this.loadPage();
      this.loadData();
      // this.autoLoadPage();
  }
  autoLoadPage() {
    $('.js-item__material').each(function () {
      if ($(this).hasClass('item__material--active')) {
          console.log('[ AjaxAutoLoadPage ] Get_Constructor');

          $.ajax({method: "POST",url:'/constructor/Get_Constructor/', data: $(this).data()}).then((data) => {
            if (data.ok) {
                $('#ajax-place').html(data.content);
                this.upd = new AjaxUpdate();
                this.cart = new AjaxCart();
                this.emb = new Embroidery();
                this.aks = new Aks();
                Material();
            } else {
                console.error('Can\'t get page');
            }
          })
          $('.js-item__material').removeClass('item__material--active');
          $(this).addClass('item__material--active');
          return false;
        }
    })
  }
  loadPage() {
    $('._js-item__material').click(function () {
      if (!$(this).hasClass('item__material--active')) {
          console.log('[ AjaxLoadPage ] Get_Constructor');

          $.ajax({method: "POST", url:'/constructor/Get_Constructor/', data: $(this).data()}).then((data) => {
            if (data.ok) {
                $('#ajax-place').html(data.content);
                this.upd = new AjaxUpdate();
                this.cart = new AjaxCart();
                this.emb = new Embroidery();
                this.aks = new Aks();
                Material();
            } else {
                console.error('Can\'t get page');
            }
          })
          $('.js-item__material').removeClass('item__material--active');
          $(this).addClass('item__material--active');
        }
        return false;
    })
  }
  loadData() {
    $.ajax({method: "POST", url:'/json/GetData/', data: {}}).then((data) => {
      if (data.ok) {
        $('.js-data[rel=header-1]').html(data.header_1);
        $('.js-data[rel=header-2]').html(data.header_2);
        $('.js-data[rel=footer]').html(data.footer);
        $('.js-data[rel=city_name]').html(data.city_name);
        if (data.city_id) {
          $('.js-city-item').removeClass('is-active');
          $('.js-city-item[data-city_id=' + data.city_id + ']').addClass('is-active');
        }
        new FlexLink();
      }
    })
  }
};

export {
  AjaxLoadPage
};
